import React, { Fragment, useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { connect, useDispatch } from "react-redux";
import { compose } from "recompose";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import SearchIcon from "@material-ui/icons/Search";
import { Typography } from "@material-ui/core";
import { searchSubscribers } from "../../../redux/actions";
import { useConstant } from "../../../utilities/useConstant";
import {
  debounceMilliseconds,
  minimumSearchCharacters,
} from "../../../utilities/constants";
import { subscriberSearchTermSelector } from "../../../redux/selectors";

var debounce = require("lodash/debounce");

const SearchBar = ({ intl, onSearchChange, subscriberFilter }) => {
  const dispatch = useDispatch();
  const [filter, setCurrentFilter] = useState(0);

  useEffect(() => {
    setCurrentFilter(subscriberFilter);
    onSearchChange(subscriberFilter);
  }, []);

  const onChange = (e) => {
    setCurrentFilter(e.target.value);
    OnSearchChanged(e.target.value);
  };

  const changeFilter = (value) => {
    if (value && value.length >= minimumSearchCharacters) {
      dispatch(searchSubscribers(value));
    }
    if (!value || value.length === 0) {
      dispatch(searchSubscribers(""));
    }

    if (onSearchChange) {
      onSearchChange(value);
    }
  };

  const OnSearchChanged = useConstant(() =>
    debounce(changeFilter, debounceMilliseconds, { leading: false }),
  );
  return (
    <div>
      <Fragment style={{ width: "100%" }}>
        <Paper
          style={{ width: "100%", padding: "10px", boxSizing: "border-box" }}
        >
          <InputBase
            fullWidth
            placeholder={intl.formatMessage({
              id: "app.general.searchPlaceholder",
            })}
            startAdornment={
              <div style={{ margin: "2px 10px 0 4px" }}>
                <SearchIcon />
              </div>
            }
            value={filter}
            onChange={onChange}
            style={{ minHeight: "34px", lineHeight: "normal" }}
          />
        </Paper>
        <Typography
          variant="body2"
          style={{
            paddingTop: "4px",
            paddingBottom: "16px",
            textAlign: "left",
          }}
        >
          {intl.formatMessage({ id: "app.subscribers.search" })}
        </Typography>
      </Fragment>
    </div>
  );
};

const mapStateToProps = (state) => ({
  subscriberFilter: subscriberSearchTermSelector(state),
});

const mapDispatchToProps = () => ({});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
);

export default enhance(SearchBar);
